
import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Container,
  TextField,
  Button,
  Card,
  CardMedia,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import AdminLayout from './Admin_Layout/AdminLayout';
import { useLocation } from 'react-router-dom';
import JoditEditor from 'jodit-react';


const AddBooks = () => {
  const location = useLocation();
  const editor = useRef(null)
  console.log('location state: ' + location.state);
  const { update = false, formData = {} } = location.state || {}; // Retrieve state or use defaults
  const [editorType, setEditorType] = useState('default'); // 'default' or 'custom'
  const [courseData, setCourseData] = useState({
    courseName: '',
    description: '',
    grade: '',
    chapterCount: '',
    periods: '',
    image: '',
    preview: '',
    type: '',
    isVisible: false,
    details: {
      sections: Array(7).fill({ description: [] }), // Initialize sections with 7 empty objects
    },
    longDescription: '',
    link: '',
    enquire: '',
    ...formData,
  });

  console.log('formdata received: ' + JSON.stringify(formData, null, 2));
  console.log('formdata link: ' + formData.link)

  useEffect(() => {
    if (update && formData) {
      setCourseData({
        ...formData,
        preview: formData.image ? `${formData.image}` : '',
        details: {
          sections: formData.details?.sections || Array(7).fill({ description: [] }), // Ensure sections is initialized
        },
      });
    }
  }, [update, formData]);

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    console.log(name + ' ' + value);
    const sectionMatch = name.match(/^section(\d+)-part(\d+)$/);
    const imageMatch = name.match(/^(image\d?)(\d+)$/);

    setCourseData((prev) => {
      const updatedData = {
        ...prev,
        details: {
          ...prev.details,
          sections: [...prev.details.sections], // Ensure immutability
        },
      };

      if (sectionMatch) {
        const sectionIndex = Number(sectionMatch[1]) - 1;
        const descIndex = Number(sectionMatch[2]) - 1;

        if (!updatedData.details.sections[sectionIndex]) {
          updatedData.details.sections[sectionIndex] = { description: [] }; // Initialize if missing
        }

        updatedData.details.sections[sectionIndex] = {
          ...updatedData.details.sections[sectionIndex], // Ensure immutability
          description: [
            ...(updatedData.details.sections[sectionIndex].description || []),
          ],
        };

        updatedData.details.sections[sectionIndex].description[descIndex] = value;
      } else if (imageMatch) {
        const imageKey = imageMatch[1];
        const sectionIndex = Number(imageMatch[2]) - 1;

        if (!updatedData.details.sections[sectionIndex]) {
          updatedData.details.sections[sectionIndex] = {}; // Initialize if missing
        }

        updatedData.details.sections[sectionIndex] = {
          ...updatedData.details.sections[sectionIndex], // Ensure immutability
          [imageKey]: value,
        };
      } else {
        updatedData[name] = value;
      }

      return updatedData;
    });
  };

  const handleImageChange = (e) => {
    const { value } = e.target;
    setCourseData((prev) => ({
      ...prev,
      image: value,
      preview: value, // Set preview to the image path directly
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('book id: ' + formData._id);
    console.log('link: ' + courseData.link)
    if (editorType === 'default') {
      setCourseData((prev) => {
        return { ...prev, link: '' }
      })
    }
    else {
      setCourseData((prev) => {
        return { ...prev, longDescription: '' }
      })
    }
    console.log('formData: ' + courseData.link)
    const endpoint = update
      ? `${process.env.REACT_APP_API_URL}/api/weoffer/${formData._id}`
      : `${process.env.REACT_APP_API_URL}/api/weoffer`;
    const method = update ? 'PUT' : 'POST';

    try {
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(courseData)
      });

      const result = await response.json();
      if (!response.ok) {
        console.log('Error details:', result);
        throw new Error(result.message || 'Failed to save course');
      }

      alert(update ? 'Book updated successfully!' : 'Book added successfully!');
      console.log('Saved course:', result);
    } catch (error) {
      console.error('Error saving course:', error);
      alert(`Error saving course: ${error.message}`);
    }
  };

  const config = useMemo(() => ({
    readonly: false,
    placeholder: "Enter Long Description",
    events: {
      change: (newContent) => {
        // Update state but don't trigger unnecessary re-renders
        setCourseData((prev) => ({ ...prev, longDescription: newContent }));
      },
      // Ensure focus is kept
      focus: () => {
        if (editor.current) {
          editor.current.focus();  // Keep focus on the editor
        }
      }
    }
  }), []);


  return (
    <AdminLayout>
      <Box sx={{ p: { xs: 2, sm: 3 }, pt: { xs: 8, sm: 9 } }}>
        <Container maxWidth="lg">
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography variant="h4" gutterBottom>
              {update ? 'Update Book' : 'Add New Book'}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
              <Grid container spacing={3}>
                {/* Book Name */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Book Name"
                    name="courseName"
                    value={courseData.courseName}
                    onChange={handleInputChange}
                    placeholder="Enter Book Name"
                  />
                </Grid>

                {/* Grade */}
                {(!update || (update && formData.type === 'book')) && (
                  <>
                    {/* Grade */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Grade"
                        name="grade"
                        value={courseData.grade}
                        onChange={handleInputChange}
                      />
                    </Grid>

                    {/* Chapter Count */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        type='number'
                        label="Number of Chapters"
                        name="chapterCount"
                        value={courseData.chapterCount}
                        onChange={handleInputChange}
                      />
                    </Grid>

                    {/* Periods */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Number of Periods"
                        name="periods"
                        value={courseData.periods}
                        onChange={handleInputChange}
                      />
                    </Grid>
                  </>
                )}

                {/* Type Dropdown */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select
                      label="Type"
                      name="type"
                      value={courseData.type}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="book">Book</MenuItem>
                      <MenuItem value="lms">LMS</MenuItem>
                      <MenuItem value="cpd">CPD</MenuItem>
                      <MenuItem value="dlab">DLab</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Description */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={courseData.description}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                    inputProps={{ maxLength: 250 }}
                    helperText={`${courseData.description.length}/250 characters`}
                  />
                </Grid>

                {/* Image Upload */}
                <Grid item xs={12}>
                  <TextField
                    label="Image Path"
                    fullWidth
                    name="image"
                    value={courseData.image}
                    onChange={handleImageChange}
                    placeholder="Enter Image URL"
                  />
                </Grid>

                {/* Image Preview */}
                {courseData.preview && (
                  <Grid item xs={12}>
                    <Card sx={{ maxWidth: 200, mt: 2 }}>
                      <CardMedia
                        component="img"
                        image={courseData.preview}
                        alt="Image Preview"
                      />
                    </Card>
                  </Grid>
                )}

                {/* Is Visible Checkbox */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={courseData.isVisible}
                        onChange={(e) => setCourseData(prev => ({ ...prev, isVisible: e.target.checked }))}
                        name="isVisible"
                        color="primary"
                      />
                    }
                    label="Is Visible"
                  />
                </Grid>

                <Grid item xs={12}>

                  {/* Radio Buttons */}
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={editorType}
                      onChange={(e) => setEditorType(e.target.value)}
                    >
                      <FormControlLabel
                        value="default"
                        control={<Radio />}
                        label="Default"
                      />
                      <FormControlLabel
                        value="custom"
                        control={<Radio />}
                        label="Custom"
                      />
                    </RadioGroup>
                  </FormControl>

                  {/* Conditional Rendering */}
                  {editorType === 'default' ? (
                    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                      <JoditEditor
                        ref={editor}
                        value={courseData.longDescription}
                        config={config}
                        tabIndex={1}
                      />
                    </Box>
                  ) : (
                    <TextField
                      fullWidth
                      multiline
                      rows={1}
                      value={courseData.link}
                      name='link'
                      onChange={handleInputChange}
                      placeholder="Enter Link for Long Description page"
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Enquire Button URL"
                    fullWidth
                    name="enquire"
                    value={process.env.REACT_APP_API_URL + '/offerings/books/enquire'}
                    onChange={handleInputChange}
                    placeholder="Enter Enqurie Button URL"
                    disabled
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 2 }}
                  >
                    {update ? 'Update Book' : 'Add Book'}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </Box>
    </AdminLayout>
  );
};

export default AddBooks;


